export default __webpack_public_path__ + "media/images/icosmall-ac097c020172922d2ca9fc1a40cc918b.png";